export default __webpack_public_path__ + "3b219330362c7090eaf4044df83f16d6.png";